import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from "../api/api.service";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private api: ApiService) {
  }

  createPortalSession(cbCustomerId: string): Observable<string> {
    const endpoint = 'organisation/create-portal-session';
    const body = {
      chargebee_customer_id: cbCustomerId,
    };
    return this.api.post(endpoint, body).pipe(map((res: any) => res.data));
  }

}
